import { render } from "./MainNavigationItem.vue?vue&type=template&id=4f67e62f&ts=true"
import script from "./MainNavigationItem.vue?vue&type=script&lang=ts"
export * from "./MainNavigationItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__